module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "konfigurator-info"
    }
  }, [(!_vm.showInfo) ? _c('a', {
    on: {
      "click": _vm.onClick
    }
  }, [_vm._v("Proč tuto informaci potřebujeme?")]) : _vm._e(), _vm._v(" "), (_vm.showInfo) ? _c('div', {
    staticClass: "konfigurator-info-content"
  }, [_c('div', {
    staticClass: "konfigurator-info-close",
    on: {
      "click": _vm.onClick
    }
  }), _vm._v(" "), (_vm.html.nazev) ? _c('h2', [_vm._v(_vm._s(_vm.html.nazev))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "konfigurator-info-popis",
    domProps: {
      "innerHTML": _vm._s(_vm.html.popis)
    }
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f240d18","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Info.vue
// module id = 575
// module chunks = 1